export class ContryConst {
  public static UKRAINE = "UA";
  public static CHINA = "CN";
  public static SWITZERLAND = "CH";
  public static GERMANY = "DE";
  public static AUSTRIA = "AT";
}
